import axios from 'axios';

import { apiHost } from 'api/apiHost';

export function postSalesforceOnboardingFormData(data: any) {
  return axios.post(`${apiHost}/api/form/submitcase`, data);
}
export function postSalesforceFormDataToEloqua(submitUrl: string, data: any) {
  return axios.post(submitUrl, data);
}
